<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item ">
    <h1>როგორ შეგვიძლია ლიზინგის გამოყენება აგროსფეროში? - მომენტები აგროექსპორტის ფორუმიდან</h1>
    <h5 style="font-family: NUSXURI;text-align: left"></h5>
    <h6>დეკემბერი 2020</h6>

    <p>
      მსოფლიოში არსებული ეპიდემიოლოგიური ვითარების გათვალისწინებით, ღონისძიებების ჩატარება დაუშვებელია, სოფლის
      მეურნეობისა და კვების მრეწველობის დარგების განვითარება კი, აქ,ახლა ისეთი მნიშვნელოვანია, როგორც არასდროს. სწორედ
      ამიტომ, წელს, ექსპოჯორჯიამ სოფლის მეურნეობისა და კვების მრეწველობის ექსპორტის პირველ მასშტაბურ ონლაინ ფორუმს
      უმასპინძლა.
    </p>

    <p>
      ფორუმი მთლიანად B2B ფორმატში, ონლაინ შეხვედრების კომპონენტით ჩატარდა და აერთიანებდა პანელურ დისკუსიებსა და
      ვორქშოპებს. ფორუმის ძირითადი მიზანი იყო აგრო და კვების მრეწველობის პროდუქტების მწარმოებლების ხელშეწყობა
      სარეალიზაციო არხების პოვნასა და გაფართოებაში, როგორც ადგილობრივ, ისე საერთაშორისო ბაზარზე.
    </p>

    <p>
      აგროექსპორტის საერთაშორისო ონლაინ გამოფენის ფარგლებში, პანელური დისკუსიის ერთ-ერთი თემა იყო — როგორ შეგვიძლია
      ლიზინგის გამოყენება აგროსფეროში, რომელზეც ჩვენმა წარმომადგენელმა ისაუბრა.
    </p>

    <p>
      <strong
        >გთავაზობთ ინტერვიუს თიბისი ლიზინგის წარმოებისა და სოფლის მეურნეობის სექტორის უფროსთან და პანელური დისკუსიის
        სპიკერთან, თეკლა რობაქიძესთან, რომელიც ამ თემის შესახებ კიდევ ერთხელ გვიამბობს.</strong
      >
    </p>
    <img src="../../../../assets/blog/bforum/img1.jpg" alt="" />
    <p>
      <strong>თეკლა, რას ვგულისხმობთ, როდესაც ვსაუბრობთ პროდუქტ ლიზინგზე სოფლის მეურნეობის სექტორისთვის?</strong
      ><br /><br />
      ლიზინგის საშუალებით აქტივების, ძირითადი საშუალებების შეძენა მარტივი და მოსახერხებელია ნებისმიერი ბიზნეს
      სექტორისთვის, მათ შორის სოფლის მეურნეობის სექტორისთვისაც.
    </p>
    <p>
      სოფლის მეურნეობის მიმართულებით ლიზინგით შეიძლება დაფინანსდეს ნებისმიერი ინვენტარი და ტექნიკა, რომელიც საჭიროა
      მოსავლის მოვლა-შენახვისთვის, აღებისა და შემდგომ მისი გადამუშავებისთვის. ვგულისხმობ, რომ მომხმარებლის მიერ შერჩეულ
      ნივთს, მაგალითად ტრაქტორს, თიბისი ლიზინგი იყიდის მომწოდებლისგან და სარგებლობაში გადასცემს ლიზინგის მიმღებს
      ყოველთვიური, განსაზღვრული გადასახადის სანაცვლოდ, გრაფიკის დასრულების შემდეგ კი, მიმღები თავის სახელზე გადაიფორმებს
      აღნიშნულ აქტივს, ამ შემთხვევაში ტრაქტორს.
    </p>
    <p>
      სოფლის მეურნეობის მიმართულებით აქტიურად ვაფინანსებთ ტრაქტორებს, კომბაინებს, მოსავლის ამკრეფ მანქანებს,სარწყავ
      სისტემებსა და მანქანა-დანადგარებს ნედლეულის გადამუშავებისთვის.
    </p>
    <img src="../../../../assets/blog/bforum/img2.jpg" alt="" />

    <p>
      <strong
        >რა უპირატესობებს ფლობს ლიზინგი სოფლის მეურნეობაში ჩართული იმ პირებისთვის, რომლებსაც დაფინანსების წყარო
        სჭირდებათ?</strong
      ><br /><br />

      ლიზინგის დამტკიცების პროცესი არის მარტივი და მოქნილი — დაფინანსების განხილვისას ვითვალისწინებთ, როგორც
      მომხმარებლის არსებულ შემოსავლებს, ასევე მის სამომავლო გათვლებს. მნიშვნელოვანი ფაქტორია, რომ ჩვენთვის თავად
      დასაფინანსებელი აქტივი წარმოადგენს ლიზინგის უზრუნველყოფას და არ ვითხოვთ დამატებით უძრავი ქონების წარმოდგენას.
    </p>
    <p>
      ამავდროულად, აქტიურად ვართ ჩართულები სოფლის მეურნეობის სააგენტოს მიმდინარე პროექტებში, რაც ნიშნავს იმას, რომ
      მომხმარებელს ჩვენი გავლით აქვს მათთან კომუნიკაცია და პროექტების სუბსიდირების პროგრამებში ჩართვაც ჩვენი ხელშეწყობით
      შეუძლია.
    </p>
    <p>
      გარდა ამისა, თუ მომხმარებელს სურვილი აქვს, ჩვენ მას ვეხმარებით მომწოდებლებთან ურთიერთობაში, რადგან საქართველოს
      ბაზარზე არსებულ სოფლის მეურნეობის ტექნიკის თითქმის ყველა იმპორტიორთან მწავალწლიანი ურთიერთობა გვაქვს. შესაბამისად,
      შეგვიძლია მომხმარებელი დავაკავშიროთ მათთან და დავეხმაროთ სასურველი აქტივის შერჩევაში.
    </p>
    <p>
      იმ შემთხვევაში, თუ პირს ნივთის შეძენა საზღვარგარეთიდან სურს, ვაფორმებთ კონტრაქტს უცხოელ მომწოდებლებთან.
      ბუნებრივია, კონტრაქტი იცავს მას აქტივის საზღვარგარეთ შეძენასა და ჩამოტანასთან დაკავშირებული რისკებისგან.
      ამავდროულად, განბაჟების პროცესს უზრუნველყოფს ჩვენი მხარე, სალიზინგო კომპანია — რაც დამატებითი კომფორტია ლიზინგის
      მიმღებისთვის.
    </p>
    <img src="../../../../assets/blog/bforum/img3.jpg" alt="" />
    <p>
      <strong
        >რას გულისხმობს უკულიზინგი და რამდენად ხშირად მიმართავენ მას სოფლის მეურნეობის სექტორში ჩართული
        ადამიანები?</strong
      ><br /><br />

      უკულიზინგი მომხმარებლის საკუთრებაში არსებული აქტივის სანაცვლოდ დაფინანსების გაცემაა. მაგალითად, თუ გაქვს საკუთარი
      კომბაინი, მისი უზრუნველყოფით შეძლებ დაფინანსების მიღებას. Უკულიზინგი ძალიან მოსახერხებელი პროდუქტია მათთვის, ვისაც
      სურს დამატებითი ფულადი სახსრები ბიზნესთან დაკავშირებული ნებისმიერი მოთხოვნის დასაფინანსებლად. Მარტივად რომ ვთქვათ,
      თუ გაქვს აქტივი, მაგრამ არ გაქვს თანხა ნედლეულის შესაძენად, შეგიძლია შენი აქტივი ფულად აქციო.
    </p>
    <p>
      <strong>ბაზრის მიმოხილვა და ლიზინგის ტენდენციის ზრდა</strong><br /><br />

      <mark class="mark-blue" style="background-color: #004083"
        >თიბისი ლიზინგის მიერ დაფინანსებული ფერმერების და გადამამუშავებელი ქარხნების რაოდენობა ყოველწლიურად იზრდება,
        იზრდება დაფინანსებული თანხების მოცულობაც.
      </mark>
      <br />
      <br />
      <mark class="mark-blue" style="background-color: #004083"
        >ბოლო წლებში სახნავ-სათესი და ნარგავებისთვის განკუთვნილი მიწების ათვისების წყალობით, გაჩნდა უფრო მეტი მოთხოვნა
        ტრაქტორების, მისაბმელებისა და კომბაინების დაფინანსებაზე.
      </mark>
      <br />
      <br />
      <mark class="mark-blue" style="background-color: #004083"
        >ასევე, ხშირია მოთხოვნა ვენახის მოვლისთვის საჭირო ტექნიკისა და ყურძნის გადამამუშავებელი ქარხნების აღჭურვილობაზე,
        სამაცივრე მეურნეობებზე, ჩირის საწარმოო და თხილის გადამამუშავებელ დანადგარებზე.
      </mark>
    </p>

    <img src="../../../../assets/blog/bforum/img4.jpg" alt="" />
    <p>
      <strong>რა უპირატესობებს სთავაზობს ლიზინგი სტარტაპებს?</strong><br /><br />

      ხშირ შემთხვევაში, სტარტაპებს დაფინანსების მოპოვება უჭირთ, რადგან საწყის ეტაპზე არ გააჩნიათ შემოსავლები - ჩვენთვის
      ეს პროცესი უფრო მარტივია, რადგან მომხმარებლის დაფინანსება სამომავლო შემოსავლებზე დაყრდნობით შეგვიძლია.
    </p>
    <p>
      ასევე , მომხმარებლებს ვთავაზობთ მათზე მორგებულ გრაფიკს, რაც გულისმხობს საშეღავათო პერიოდით სარგებლობას
      შემოსავლების დაგენერირებამდე, ან სეზონურ გადახდას ბიზნესის სპეციფიკიდან გამომდინარე.
    </p>
    <img src="../../../../assets/blog/bforum/img5.jpg" alt="" />
    <p>
      <strong
        >რა არის ის სამომავლო ამოცანები, რომელიც გააძლიერებს სექტორს და ასევე, ამ სფეროში ლიზინგის პოპულარიზაციას
        შეუწყობს ხელს?</strong
      ><br /><br />

      მსოფლიოში მიმდინარე პროცესებიდან გამომდინარე, წინა წლებთან შედარებით, სოფლის მეურნეობის სექტორი გაცილებით
      პოპულარული გახდა. მომრავლდა ამ მიმართულების წამახალისებელი პროგრამები და შესაბამისად, ამ სფეროთი სულ უფრო და უფრო
      მეტი ადამიანი ინტერესდება. თიბისი ლიზინგი თავის მხრივ აქტიურად მონაწილეობს სხვადასხვა ფორუმებში, თანამშრომლობს
      ტექნიკისა და დანადგარების იმპორტიორებსა თუ მწარმოებლებთან და მზადაა დააფინანსოს ნებისმიერი საინტერესო პროექტი,
      რომელიც დაეხმარება და განავითარებს ჩვენი ქვეყნის ეკონომიკას.
    </p>
    <p></p>

    <br />
    <div class="blog-author"><span>ავტორი: ნინჩო ბალანჩივაძე</span></div>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item ">
    <h1>How Can Leasing Be Used in the Agro-Sector? - Insights from the Agro-Export Forum</h1>
    <h5 style="font-family: NUSXURI;text-align: left"></h5>
    <h6>December 2020</h6>

    <p>
      Considering the current global epidemiological situation, holding events is not allowed, but the development of
      the agricultural and food industries is now more important than ever. This is why ExpoGeorgia hosted the first
      large-scale online agro-export forum this year.
    </p>

    <p>
      The forum was held entirely in a B2B format, with online meetings, panel discussions, and workshops. Its main goal
      was to support producers of agro and food products in finding and expanding their sales channels, both locally and
      internationally.
    </p>

    <p>
      One of the topics discussed during the forum was how leasing can be used in the agro-sector, a subject on which
      our representative spoke.
    </p>

    <p>
      <strong>
        We offer an interview with TBC Leasing's Head of Production and Agro-Sector, Thekla Robakidze, who elaborates
        further on this topic.
      </strong>
    </p>
    <img src="../../../../assets/blog/bforum/img1.jpg" alt="" />
    <p>
      <strong>Thekla, what do we mean when we talk about product leasing for the agricultural sector?</strong
      ><br /><br />
      Leasing makes the purchase of assets and equipment simple and convenient for any business sector, including
      agriculture. In the agro-sector, leasing can finance any inventory or equipment needed for harvest management,
      storage, collection, and subsequent processing.
    </p>
    <p>
      For example, when a customer selects an item, such as a tractor, TBC Leasing buys it from the supplier and
      provides it to the lessee in exchange for monthly, predefined payments. Once the payment schedule is completed,
      the lessee registers the asset, in this case, the tractor, in their name.
    </p>
    <p>
      In the agricultural sector, we actively finance tractors, combines, harvesters, irrigation systems, and machinery
      for raw material processing.
    </p>
    <img src="../../../../assets/blog/bforum/img2.jpg" alt="" />

    <p>
      <strong>
        What benefits does leasing offer for individuals in the agricultural sector who need financing? </strong
      ><br /><br />

      The approval process for leasing is simple and flexible. When considering financing, we take into account both the
      customer's existing income and their future projections. An important advantage is that the asset itself serves as
      collateral, so there’s no need to provide additional real estate.
    </p>
    <p>
      Additionally, we are actively involved in ongoing projects of the Agricultural Agency, which means that customers
      can communicate with the agency through us and participate in subsidy programs with our support.
    </p>
    <p>
      Moreover, if the customer wishes, we assist them in dealing with suppliers, as we have established long-term
      relationships with almost all agricultural equipment importers in Georgia. As a result, we can connect the
      customer with suppliers and help them select the desired equipment.
    </p>
    <p>
      If the customer wants to purchase equipment from abroad, we enter into contracts with foreign suppliers.
      Naturally, these contracts protect the customer from the risks related to purchasing and importing the equipment.
      Additionally, our leasing company takes care of the customs clearance process, which adds extra convenience for
      the lessee.
    </p>
    <img src="../../../../assets/blog/bforum/img3.jpg" alt="" />
    <p>
      <strong>
        What is "reverse leasing" and how frequently do people in the agricultural sector use it? </strong
      ><br /><br />

      Reverse leasing is the process of obtaining financing in exchange for an asset already owned by the customer. For
      example, if you own a combine, you can use it as collateral to obtain financing. Reverse leasing is a very
      convenient product for those who need additional funds to cover any business-related expenses. Simply put, if you
      have an asset but no funds to purchase raw materials, you can turn your asset into cash.
    </p>
    <p>
      <strong>Market Overview and Growing Trends in Leasing</strong><br /><br />

      <mark class="mark-blue" style="background-color: #004083">
        The number of farmers and processing plants financed by TBC Leasing has been increasing year by year, as has the
        amount of financing provided.
      </mark>
      <br />
      <br />
      <mark class="mark-blue" style="background-color: #004083">
        In recent years, due to the development of land for plowing and planting, there has been a greater demand for
        financing for tractors, trailers, and combines.
      </mark>
      <br />
      <br />
      <mark class="mark-blue" style="background-color: #004083">
        There is also frequent demand for equipment needed for vineyard care and grape processing plants, as well as for
        cold storage facilities, dried fruit production equipment, and hazelnut processing machines.
      </mark>
    </p>

    <img src="../../../../assets/blog/bforum/img4.jpg" alt="" />
    <p>
      <strong>What benefits does leasing offer to startups?</strong><br /><br />
      In many cases, startups find it challenging to secure financing because they do not have revenue at the initial
      stage. For us, this process is simpler, as we can base financing on the customer’s future income projections.
    </p>
    <p>
      Additionally, we offer customized payment schedules for customers, including grace periods until they start
      generating income or seasonal payments depending on the business’s nature.
    </p>
    <img src="../../../../assets/blog/bforum/img5.jpg" alt="" />
    <p>
      <strong
        >What are the future goals that will strengthen the sector and help popularize leasing in this area? </strong
      ><br /><br />
      Given the global trends, the agricultural sector has become much more popular than in previous years. There has
      been an increase in programs that encourage this sector, and as a result, more and more people are showing
      interest in it. TBC Leasing actively participates in various forums, cooperates with equipment and machinery
      importers and manufacturers, and is ready to finance any interesting projects that will help and develop the
      country’s economy.
    </p>
    <p></p>

    <br />
    <div class="blog-author"><span>Author: Nincho Balanchivadze</span></div>
  </div>
</ng-container>
